import { BASE_BE_URL } from "../AppEnv";
import { Doctor } from "../doctor/interfaces";
import {
  ALMSG_BADREQUEST_ERR,
  ALMSG_INTERNAL_ERR,
  ALMSG_UNAUTHORIZED_OP,
  BASE_DOC_SUBURL,
  BASE_MEDSTUDIO_SUBURL,
} from "../env";
import { StudioAdd } from "../home/AdminHome";
import { Studio } from "../studio/interfaces";

export async function getMedStudios(token: string): Promise<Studio[]> {
  try {
    let meResp = await fetch(BASE_BE_URL + BASE_MEDSTUDIO_SUBURL, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (!meResp.ok) return [];

    return await meResp.json();
  } catch (error) {
    //console.log("Error: " + error);
    return [];
  }
}

export async function getStudioMaster(
  token: string,
  studio: Studio
): Promise<string | Doctor> {
  try {
    const response = await fetch(
      BASE_BE_URL + BASE_MEDSTUDIO_SUBURL + studio.id + "/master",
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      return await response.json();
    }

    if (response.status == 400) return ALMSG_BADREQUEST_ERR;
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}

export async function addMedicalStudio(
  token: string,
  addStudio: StudioAdd
): Promise<string> {
  try {
    const response = await fetch(BASE_BE_URL + BASE_MEDSTUDIO_SUBURL, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addStudio),
    });

    if (response.ok) return "ok";

    if (response.status == 400) return ALMSG_BADREQUEST_ERR;
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}

interface DoctorEditPwd extends Doctor {
  password: string;
  passwordConfirmation: string;
}

export async function editMasterPwd(
  token: string,
  editMasterPwd: DoctorEditPwd
): Promise<string> {
  try {
    const response = await fetch(
      BASE_BE_URL +
        BASE_MEDSTUDIO_SUBURL +
        editMasterPwd.medicalStudioId +
        "/" +
        editMasterPwd.username,
      {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editMasterPwd),
      }
    );

    if (response.ok) return "ok";

    if (response.status == 400) return ALMSG_BADREQUEST_ERR;
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}

export async function editMedicalStudio(
  token: string,
  updStudio: Studio
): Promise<string> {
  if (updStudio.id == undefined || updStudio.id < 0) return "Id not valid";
  try {
    const response = await fetch(
      BASE_BE_URL + BASE_MEDSTUDIO_SUBURL + updStudio.id,
      {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updStudio),
      }
    );

    if (response.ok) return "ok";

    if (response.status == 400) return ALMSG_BADREQUEST_ERR;
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}
